import React from 'react';
import {
  IonPage,
  IonContent,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonIcon,
} from '@ionic/react';
import {
  phonePortraitOutline,
  desktopOutline,
} from 'ionicons/icons';
import { Building2 } from 'lucide-react';
import { getStoredUser } from '@shared/auth/session';

const CitizenChooseModePage: React.FC = () => {
  const user = getStoredUser<{
    display_name?: string;
    displayName?: string;
    first_name?: string;
    firstName?: string;
  }>();

  const displayName =
    user?.display_name || user?.displayName || user?.first_name || user?.firstName || 'there';

  const handleChoose = (mode: 'citizen' | 'pro') => {
    localStorage.setItem('preferredMode', mode);
    if (mode === 'citizen') {
      window.location.href = '/citizen/home';
    } else {
      window.location.href = '/dashboard';
    }
  };

  return (
    <IonPage>
      <IonContent className="ion-padding">
        <div className="citizen-ionic max-w-lg mx-auto px-4 pt-12 pb-8">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-primary-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <Building2 className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-text-primary dark:text-text-dark-primary">
              Welcome back, {displayName}
            </h1>
            <p className="text-sm text-text-secondary dark:text-text-dark-secondary mt-2">
              How would you like to use Capitol Commons today?
            </p>
          </div>

          <div className="space-y-4">
            <IonCard
              button
              onClick={() => handleChoose('citizen')}
              className="cursor-pointer"
            >
              <IonCardHeader>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-primary-100 dark:bg-primary-dark-100 rounded-xl flex items-center justify-center">
                    <IonIcon icon={phonePortraitOutline} className="text-2xl text-primary-600" />
                  </div>
                  <div>
                    <IonCardTitle className="text-base">Citizen Mode</IonCardTitle>
                  </div>
                </div>
              </IonCardHeader>
              <IonCardContent>
                <p className="text-sm text-text-secondary dark:text-text-dark-secondary">
                  Track bills, explore legislators, and stay informed about Colorado legislation
                  with a streamlined mobile experience.
                </p>
              </IonCardContent>
            </IonCard>

            <IonCard
              button
              onClick={() => handleChoose('pro')}
              className="cursor-pointer"
            >
              <IonCardHeader>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-primary-100 dark:bg-primary-dark-100 rounded-xl flex items-center justify-center">
                    <IonIcon icon={desktopOutline} className="text-2xl text-primary-600" />
                  </div>
                  <div>
                    <IonCardTitle className="text-base">Professional Mode</IonCardTitle>
                  </div>
                </div>
              </IonCardHeader>
              <IonCardContent>
                <p className="text-sm text-text-secondary dark:text-text-dark-secondary">
                  Full workspace tools, reporting, team collaboration, and advanced analytics
                  for your organization.
                </p>
              </IonCardContent>
            </IonCard>
          </div>

          <p className="text-xs text-text-tertiary dark:text-text-dark-tertiary text-center mt-6">
            You can switch between modes anytime from the toolbar.
          </p>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default CitizenChooseModePage;
